import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  SEARCH_SURVEY_STRUCTURE,
  CLEAR_SURVEY_STRUCTURE,
  CLEAR_AM,
} from "constants/actions";
import List from "./List/Index.js";
import Details from "./Detail/Index.js";
import { Button } from "components/ui/button";
import { Separator } from "components/ui/separator";
import { ArrowLeft } from "lucide-react";

function CategoryStructure() {
  const [orgName, setOrgName] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { get_survey_structure_search } = useSelector(
    (state) => ({
      get_survey_structure_search: state.surveystructure,
    }),
    shallowEqual
  );

  const [searchBox, setSearchBox] = useState("");

  useEffect(() => {
    setSearchBox(get_survey_structure_search?.search);
  }, [get_survey_structure_search]);

  function handleClearSearch() {
    dispatch({ type: SEARCH_SURVEY_STRUCTURE, payload: "" });
  }

  function handleClearAll() {
    dispatch({ type: CLEAR_SURVEY_STRUCTURE });
    dispatch({ type: CLEAR_AM });
  }

  function handleBack() {
    navigate("/app/categories/");
  }

  return (
    <>
      <div className="mt-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {orgName ? (
            <Button
              variant="ghost"
              size="icon"
              onClick={handleBack}
              aria-label="Back"
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
          ) : null}
          <div>
            <h2 className="text-2xl font-semibold tracking-tight">
              {orgName ? `Category Structure of ${orgName}` : "Category Structure"}
            </h2>
            <p className="text-sm text-muted-foreground">
              Manage Category Structure for Survey.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button variant="secondary" onClick={handleClearAll}>
            Clear All
          </Button>
          {searchBox ? (
            <Button variant="outline" onClick={handleClearSearch}>
              Clear Search
            </Button>
          ) : null}
        </div>
      </div>
      <Separator className="my-4" />

      <Routes>
        <Route path="/" element={<List setOrgName={setOrgName} />} />
        <Route path="details/:id" element={<Details setOrgName={setOrgName} />} />
        <Route path="create" element={<Details setOrgName={setOrgName} />} />
      </Routes>
    </>
  );
}

export default CategoryStructure;
